module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020-desktop/0030.jpg?v=289df0c6";